/*
 * Copyright (c) 2020 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('member.dinghy-events', {
            parent: 'member',
            url: '/member/dinghy-events',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'askApp.booking.home.title2'
            },
            views: {
                'content@': {
                    templateUrl: 'app/member/dinghy-events/dinghy-events.html',
                    controller: 'DinghyEventsMemberController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    $translatePartialLoader.addPart('booking');
                    $translatePartialLoader.addPart('dinghyBooking');
                    $translatePartialLoader.addPart('dinghyEvent');
                    $translatePartialLoader.addPart('enumBookingStatusType');
                    $translatePartialLoader.addPart('enumDinghyEventType');
                    return $translate.refresh();
                }]
            }
        })
        .state('member.dinghy-events.book', {
            parent: 'member.dinghy-events',
            url: '/book/{id}',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/member/dinghy-events/dinghy-booking-dialog.html',
                    controller: 'MemberDinghyBookingDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: ['DinghyBookingMember', function(DinghyBookingMember) {
                            return DinghyBookingMember.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('member.dinghy-events', null, { reload: 'member.dinghy-events' });
                }, function() {
                    $state.go('member.dinghy-events');
                });
            }]
        })
        .state('member.dinghy-events.change', {
            parent: 'member.dinghy-events',
            url: '/change/{id}',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/member/dinghy-events/dinghy-booking-change-dialog.html',
                    controller: 'MemberDinghyBookingChangeController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: ['DinghyBookingDetailMember', function(DinghyBookingDetailMember) {
                            return DinghyBookingDetailMember.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function(result) {
                    $state.go('member.dinghy-events', null, { reload: 'member.dinghy-events' });
                }, function() {
                    $state.go('member.dinghy-events');
                });
            }]
        })
        .state('member.dinghy-events.detail', {
            parent: 'member.dinghy-events',
            url: '/detail/{id}',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/member/dinghy-events/dinghy-booking-detail-dialog.html',
                    controller: 'MemberDinghyBookingDetailDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: ['DinghyBookingDetailMember', function(DinghyBookingDetailMember) {
                            return DinghyBookingDetailMember.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('member.dinghy-events', null, { reload: 'member.dinghy-events' });
                }, function() {
                    $state.go('member.dinghy-events');
                });
            }]
        });
    }
})();
